// This function replaces browser URL outside of React Router to avoid triggering
// a rerender and to be able to open a site modal without triggering route change.
// See: https://stackoverflow.com/questions/57101831/react-router-how-do-i-update-the-url-without-causing-a-navigation-reload
// Other ways of changing route would trigger unwanted route changes and re-renders
// (see: https://github.com/ReactTraining/react-router/issues/266 for similar use case)
export const replaceUrlOutsideOfRR = (href: string) => {
  window.history.replaceState(null, '', href);
};
